/* ═══════════════════════════════════════════════════════════════════════
   OTMENS Shopify Theme — JavaScript
   ═══════════════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  /* ── Mobile Menu ── */
  function initMobileMenu() {
    var btn = document.getElementById('mobile-menu-btn');
    var menu = document.getElementById('mobile-menu');
    if (!btn || !menu) return;

    var header = document.querySelector('.site-header');
    var logo = document.querySelector('.site-header__logo');
    var closeBtn = document.getElementById('mobile-menu-close');

    function openMenu() {
      menu.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      if (header) {
        header.style.backgroundColor = '#1B1A1A';
        header.style.borderBottomColor = 'transparent';
      }
      var bars = btn.querySelectorAll('.site-header__bar');
      if (bars[0]) { bars[0].style.transform = 'translateY(6.5px) rotate(45deg)'; bars[0].style.backgroundColor = '#FDFDFC'; }
      if (bars[1]) { bars[1].style.opacity = '0'; }
      if (bars[2]) { bars[2].style.transform = 'translateY(-6.5px) rotate(-45deg)'; bars[2].style.backgroundColor = '#FDFDFC'; }
      if (logo) logo.style.filter = 'brightness(0) invert(1)';
      document.body.style.overflow = 'hidden';
    }

    function closeMenu() {
      menu.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
      if (header) {
        header.style.backgroundColor = '';
        header.style.borderBottomColor = '';
      }
      var bars = btn.querySelectorAll('.site-header__bar');
      if (bars[0]) { bars[0].style.transform = ''; bars[0].style.backgroundColor = ''; }
      if (bars[1]) { bars[1].style.opacity = ''; }
      if (bars[2]) { bars[2].style.transform = ''; bars[2].style.backgroundColor = ''; }
      if (logo) logo.style.filter = '';
      document.body.style.overflow = '';
    }

    btn.addEventListener('click', function () {
      menu.classList.contains('is-open') ? closeMenu() : openMenu();
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', closeMenu);
    }

    document.addEventListener('click', function (e) {
      if (!btn.contains(e.target) && !menu.contains(e.target)) closeMenu();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeMenu();
    });
  }

  /* ── Marquee ── */
  function initMarquee() {
    var container = document.querySelector('.marquee-container');
    if (!container) return;
    var track = container.querySelector('.marquee-track');
    var groups = container.querySelectorAll('.marquee-group');
    if (!track || !groups.length) return;

    function calculateSpeed() {
      var contentWidth = groups[0].offsetWidth;
      var baseSpeed = 30;
      var speedMultiplier = contentWidth / 1000;
      var calculatedSpeed = Math.max(20, baseSpeed * speedMultiplier);
      container.style.setProperty('--marquee-speed', calculatedSpeed + 's');
    }

    calculateSpeed();
    var resizeTimeout;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(calculateSpeed, 250);
    });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        track.style.animationPlayState = entry.isIntersecting ? 'running' : 'paused';
      });
    }, { threshold: 0 });
    observer.observe(container);

    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (prefersReducedMotion.matches) track.style.animation = 'none';
    prefersReducedMotion.addEventListener('change', function (e) {
      track.style.animation = e.matches ? 'none' : '';
    });
  }

  /* ── Newsletter Form ── */
  function initNewsletter() {
    var form = document.getElementById('footer-newsletter-form');
    var msg = document.getElementById('footer-newsletter-msg');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = form.querySelector('input[type="email"]');
      var email = (input && input.value || '').trim();
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        if (msg) { msg.style.color = '#ff8a8a'; msg.textContent = 'Please enter a valid email.'; }
        return;
      }
      if (msg) { msg.style.color = '#febb00'; msg.textContent = "Thanks \u2014 we'll be in touch."; }
      form.reset();
    });
  }

  /* ── Product Page: Quantity ── */
  function initQuantitySelectors() {
    document.querySelectorAll('.product-form__quantity').forEach(function (wrapper) {
      var input = wrapper.querySelector('.product-form__qty-input');
      if (!input) return;
      wrapper.querySelectorAll('.product-form__qty-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var current = parseInt(input.value, 10) || 1;
          if (btn.dataset.action === 'decrease') {
            input.value = Math.max(1, current - 1);
          } else {
            input.value = current + 1;
          }
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ── Product Page: Thumbnail Gallery ── */
  function initProductGallery() {
    var thumbs = document.querySelectorAll('.product-page__thumb');
    var mainImg = document.querySelector('.product-page__main-image img');
    if (!thumbs.length || !mainImg) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        var src = thumb.dataset.src || thumb.querySelector('img').src;
        mainImg.src = src;
      });
    });
  }

  /* ── Init ── */
  document.addEventListener('DOMContentLoaded', function () {
    initMobileMenu();
    initMarquee();
    initNewsletter();
    initQuantitySelectors();
    initProductGallery();
  });
})();
